
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 257.567 257.567"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M226.657 97.909a5.545 5.545 0 00-.267-1.354c-.065-.179-.114-.359-.196-.544-.261-.571-.593-1.115-1.055-1.577 0-.005-.005-.011-.005-.011L132.3 1.594c-.468-.468-1.023-.8-1.599-1.066-.158-.071-.315-.114-.479-.169a5.107 5.107 0 00-1.425-.288C128.683.06 128.574 0 128.46 0H67.113C47.108 0 30.839 16.274 30.839 36.279v185.015c0 20.005 16.274 36.273 36.273 36.273h123.342c19.999 0 36.273-16.268 36.273-36.273V98.273c0-.125-.065-.239-.07-.364zm-92.769-79.34l74.27 74.265h-48.875c-14.006 0-25.395-11.389-25.395-25.395v-48.87zm56.566 228.114H67.113c-14.006 0-25.395-11.395-25.395-25.395V36.279c0-14.006 11.395-25.4 25.395-25.4h55.897V67.44c0 20.005 16.274 36.273 36.273 36.273h56.566v117.576c0 14.005-11.389 25.394-25.395 25.394z","fill":"#010002"}})])
          )
        }
      }
    